import React from 'react';
import DesktopCategories from './DesktopCategories';
import ExploreWorldCategories from './ExploreWorldCategories';
import BackpackTrips from './BackpackTrips';
import RomanticGateways from './RomanticGateways';
import LadakhBikeTrips from './LadakhBikeTrips';

const Categories = () => {
  const styles = {
    categoriesContainer: {
      background: 'linear-gradient(to bottom, #fff5c3 0%, #ffffff 50%, #fff5c3 100%)',
      padding: '20px 0',
      position: 'relative',
      overflow: 'hidden',
    },
    sectionTitle: {
      textAlign: 'center',
      color: '#333',
      marginTop: '30px',
      marginBottom: '15px',
      fontSize: '2.2em',
      fontWeight: 'bold',
      textShadow: '1px 1px 3px rgba(0, 0, 0, 0.1)',
    },
    subtitle: {
      textAlign: 'center',
      color: '#555',
      marginBottom: '40px',
      fontSize: '1.1em',
      maxWidth: '800px',
      margin: '0 auto 40px auto',
    }
  };

  return (
    <div style={styles.categoriesContainer}>
      <h2 style={styles.sectionTitle}>Explore Dream Destinations</h2>
      <p style={styles.subtitle}>
        Discover our handpicked selection of top destinations for your next adventure
      </p>
      <DesktopCategories />
      <ExploreWorldCategories />
      <RomanticGateways />
      <LadakhBikeTrips />
      <BackpackTrips />
    </div>
  );
};

export default Categories;
